import { Injectable } from '@angular/core';
import { Promotion } from '@shared/services/elastic-search/models';
import { StoreBase } from '@stores/abstract';

@Injectable({ providedIn: 'root' })
export class PromotionStore extends StoreBase<Promotion> {
  override storeName = 'PromotionStore';
}
